<p-dialog
  [visible]="deleteDigitalPassModal()"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [closeOnEscape]="true"
  (onHide)="closeDialogEvent()"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '580px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form
      [formGroup]="deleteDigitalPassFromGroup"
      (ngSubmit)="deleteDigitalPass()"
    >
      <!-- Content -->
      <div class="surface-0 relative p-3 md:p-4">
        <div
          class="fa fa-times text-xl text-600 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="closeDialogEvent()"
        ></div>

        <div class="text-center">
          <div class="relative inline-block mb-3">
            @if (!allClientData.image) {
              <p-avatar
                [label]="allClientData.full_name | titlecase | shortName"
                shape="circle"
                styleClass="lg:w-6rem lg:h-6rem w-3rem h-3rem text-2xl md:text-3xl"
              />
            }
            @if (allClientData.image) {
              <p-avatar
                [image]="allClientData.image"
                shape="circle"
                styleClass="lg:w-6rem lg:h-6rem w-3rem h-3rem"
              />
            }
          </div>

          <h4 class="text-lg mb-1">
            <span>{{ 'DELETE_DIGITAL_PASS.DELETE' | translate }}</span>
            {{ allClientData.full_name
            }}{{ 'DELETE_DIGITAL_PASS.CLIENT_PROFILE' | translate }}
          </h4>
          <p class="text-600 mb-0">
            {{
              'DELETE_DIGITAL_PASS.ARE_YOU_SURE_YOU_WANT_TO_DELETE' | translate
            }}
            @if (allClientData) {
              <span>{{ 'DELETE_DIGITAL_PASS.DELETE' | translate }}</span>
            }
            {{ 'DELETE_DIGITAL_PASS.THIS_PROFILE' | translate }}
          </p>
        </div>

        <div class="border-bottom-1 border-300 my-4"></div>

        <div class="mb-3">
          @if (allClientData) {
            <h5
              class="font-medium text-700 text-xs mb-2 block uppercase"
              [innerHTML]="
                'DELETE_DIGITAL_PASS.PLEASE_CONFIRM_DELETE' | translate
              "
            ></h5>
          }
          <input
            type="text"
            pInputText
            placeholder=""
            class="p-inputtext-sm w-full"
            formControlName="confirmationText"
          />
          @if (ConfirmationText.touched && ConfirmationText.invalid) {
            <app-error-msg
              [errors]="ConfirmationText.errors"
              [fieldLabel]="'BLOCK_CLIENT.CONFRIMATION_TEXT' | translate"
            />
          }
        </div>
        <!-- <ng-container *ngIf="allClientData">
          <h5 class="font-medium text-700 text-xs mb-2 block uppercase">
          {{'DELETE_DIGITAL_PASS.REASON_FOR_BLOCKING' | translate}} {{allClientData.full_name}}</h5>
          <textarea pInputTextarea class="p-inputtext-sm w-full" formControlName="confirmationDescription"></textarea>
          <app-error-msg *ngIf="ConfirmationDescription.touched && ConfirmationDescription.invalid"
            [errors]="ConfirmationDescription.errors"
            [fieldLabel]="'DELETE_DIGITAL_PASS.CONFRIMATION_DESCRIPTION' | translate">
          </app-error-msg>
        </ng-container> -->
      </div>
      <!-- Content -->

      <!-- Content -->
      <div class="surface-100 p-2">
        <ol class="list-decimal text-xs text-600 m-0">
          <li
            class="my-1"
            [innerHTML]="'DELETE_DIGITAL_PASS.CONTENT_LINE_1' | translate"
          ></li>
          <li
            class="my-1"
            [innerHTML]="'DELETE_DIGITAL_PASS.CONTENT_LINE_2' | translate"
          ></li>
          <li
            class="my-1"
            [innerHTML]="'DELETE_DIGITAL_PASS.CONTENT_LINE_3' | translate"
          ></li>
          <li
            class="my-1"
            [innerHTML]="'DELETE_DIGITAL_PASS.CONTENT_LINE_4' | translate"
          ></li>
          <li
            class="my-1"
            [innerHTML]="'DELETE_DIGITAL_PASS.CONTENT_LINE_5' | translate"
          ></li>
        </ol>
      </div>
      <!-- Content -->

      <!-- Modal Footer -->
      <div class="lg:px-4 px-2 py-3 border-top-1 border-400 surface-0">
        <div class="flex align-items-center justify-content-between">
          <div class="w-4">
            <p-button
              type="button"
              [label]="'DELETE_DIGITAL_PASS.CANCEL' | translate"
              styleClass="p-button-link text-sm"
              (click)="closeDialogEvent()"
            />
          </div>
          <div class="w-8 text-right">
            <p-button
              type="submit"
              [label]="'DELETE_DIGITAL_PASS.CONTINUE' | translate"
              [loading]="btnLoading"
              styleClass="text-sm p-button-danger"
              [disabled]="!deleteDigitalPassFromGroup.valid"
            />
          </div>
        </div>
      </div>
      <!-- Modal Footer -->
    </form>
  </ng-template>
</p-dialog>
